"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _redux = require("redux");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");
var myAccountUIActions = _interopRequireWildcard(require("../actions/myAccountUIActions"));
var authActions = _interopRequireWildcard(require("angieslist-app-platform/lib/common/auth/authActions"));
var _serviceProviderGatewayActionKeys = _interopRequireDefault(require("../constants/serviceProviderGatewayActionKeys"));
var contactPreferencesActions = _interopRequireWildcard(require("../actions/contactPreferencesActions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  getContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES, {
    'UPDATE_ASSOCIATE_CONTACT_PREF_STATE': function UPDATE_ASSOCIATE_CONTACT_PREF_STATE(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          return pref.set('enabled', currentPref.enabled);
        });
      });
      return state.merge(updatedState);
    }
  }),
  saveContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES, (0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.updateAssociateContactPrefState(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  getContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL, {
    'UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL': function UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          if (currentPref) {
            return pref.set('enabled', currentPref.enabled);
          } else {
            return pref;
          }
        });
      });
      return state.merge(updatedState);
    }
  }),
  unsubscribeFromContactPreferenceByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL, (0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateAssociateContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  saveContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateAssociateContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  }))
});
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/reducers/serviceProviderGatewayReducer.js
// module id = 4400
// module chunks = 9